export default {
  'language.usd': 'دلار',
  'language.rub': 'روبل',
  'language.eur': 'یورو',
  'language.rial': 'ریال',
  'language.german': 'Deutsche',
  'language.italian': 'Italiano',
  'language.arabic': 'عربی',
  'language.french': 'Français',
  'language.spanish': 'Español',
  'language.russian': 'русский',
  'language.english': 'English',
  'language.iran': 'فارسی',
  'language.japanese': '日本',
  'language.yen': 'ین',
  'language.persian': 'فارسی',
  'component.select': 'انتخاب',
  'form.requierd': 'فیلد اجباری است',
  'form.isshort': 'تعداد حروف کوتاه است',
  'form.islong': 'تعداد حروف زیاد است',
  'form.invalid': 'نامعتبر',
  'form.number': 'فقط عدد مجاز است',
  'alert.info': 'توجه',
  'alert.warning': 'هشدار',
  'alert.error': 'مشکل',
  'alert.notitle': ' ',
  'alert.success': 'موفقیت آمیز',
  'errorBoundary.oops': 'اوپز !!',
  'errorBoundary.weSearched': '.صفحه مورد نظر یافت نگردید',
  'errorBoundary.backToHome': 'بازگشت به خانه',
  'error.receiveerror': 'خطا در دریافت اطلاعات',
  // ////////

  'faq.faq': 'سوالات متداول',
  'faq.firstquestion': 'ماموریت گروه تریپسی چیست؟',
  'faq.firstanswer':
    'ماموریت ما این است که "تجارت در هر مکانی را آسان کنیم." بنیانگذاران ما شرکت ما را راه اندازی کردند تا از کسب و کارهای کوچک حمایت کنند، با این باور که اینترنت با امکان دادن به شرکت های کوچک برای استفاده از نوآوری و فناوری برای رشد و رقابت موثرتر در اقتصادهای داخلی و جهانی، زمینه بازی را هموار می کند. ما بر این باوریم که تمرکز بر نیازهای مشتری و حل مشکلات آنها - چه این مشتریان مصرف کننده باشند، چه تاجر یا شرکت - در نهایت به بهترین نتیجه برای کسب و کار ما منجر می شود.',
  'faq.secendquestion': 'گروه تریپسی چه زمانی تاسیس شد؟',
  'faq.secendanswer':
    'گروه تریپسی در سال 2022 توسط 18 نفر به سرپرستی مهدی عبدالهی مهر تاسیس شد و به عنوان یک بازار عمده فروشی آنلاین برای صادرکنندگان و کارآفرینان کوچک ایرانی آغاز به کار کرد تا به خریداران جهانی برسد.',
  'faq.thirdquestion': 'دفاتر گروه تریپسی کجا هستند؟',
  'faq.thirdanswer':
    'ما دفاتر خود را در بسیاری از کشورها و مناطق، از جمله سرزمین اصلی چین، هنگ کنگ، سنگاپور و ایالات متحده نگهداری می کنیم. علاوه بر این، ما مراکز داده را در تعدادی از کشورها از جمله چین، اندونزی، مالزی، استرالیا، سنگاپور، امارات، آلمان، بریتانیا، ژاپن و ایالات متحده نگهداری می کنیم.',

  NextStep: 'مرحله بعد',
  Previous: 'مرحله قبل',
  FirstName: 'نام',
  LastName: 'نام خانوادگی',
  BirthDate: 'تاریخ تولد',
  NationalCode: 'کد ملی',
  Yes: 'بلی',
  No: 'خیر',
  Jalali: 'شمسی',
  Miladi: 'میلادی',
  Hijri: 'قمری',
};
